module.exports = __webpack_public_path__ + "static/media/DONT SHOOT FILMS 3.7ef5da77.JPG";